import React from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import "./register-sidebar.style.scss";
export default function RegisterSidebar({
  steps,
  selectedStep,
  setSelectedStep,
}) {
  const history = useHistory();
  const decideClassName = (obj) => {
    if (obj.skipped && obj.number < selectedStep?.number) {
      return "skipped-step";
    }
    if (selectedStep?.number === obj?.number) {
      return "current-step";
    } else if (obj.number < selectedStep?.number) {
      return "prev-step";
    }
  };

  return (
    <div className="register-sidebar-main">
      <img className="dots-up" src={Images.topRightDots} />
      <img className="dots-bottom" src={Images.dotsLeftBottom} />
      <p className="bottom-text">
        <Link to="/contact">About AcadsHR - Contact US</Link>{" "}
      </p>

      <div className="rsm-header">
        <img
          onClick={() => history.push("/")}
          src={Images.mainLogo}
          alt="acads"
        />
      </div>
      <div className="rsm-title-info">
        <h5>You are the teacher of the world</h5>
        <p>Join us today and get recruited!</p>
      </div>
      <div className="rsm-steps-wrapper">
        {steps.map((obj) => (
          <Link
            onClick={(e) =>
              obj.number > selectedStep.number
                ? e.preventDefault()
                : setSelectedStep(obj)
            }
            to={`/register/${obj.id}`}
          >
            <div className={`step-row ${decideClassName(obj)}`}>
              <button className="num-button">
                {decideClassName(obj) === "prev-step" ? (
                  <img
                    height="18px"
                    src="https://img.icons8.com/windows/32/ffffff/checkmark.png"
                  />
                ) : (
                  obj.number
                )}
              </button>
              <div>
                <p>Step {obj.number}</p>
                <h5>
                  {obj.title}
                  <button>Incomplete</button>
                </h5>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
{
  /* <img src="https://img.icons8.com/windows/32/000000/checkmark.png"/> */
}
